export default "__VITE_ASSET__MoNuKove__"